module.exports = __webpack_public_path__ + "img/Icons-3.cdc99d4.svg";